// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flip-countdown[data-v-ac7842d4]{font-family:Roboto,sans-serif}", ""]);
// Exports
module.exports = exports;
